import { render, staticRenderFns } from "./location-select.vue?vue&type=template&id=50f99abf&scoped=true&"
import script from "./location-select.vue?vue&type=script&lang=js&"
export * from "./location-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f99abf",
  null
  
)

export default component.exports